import BlurredBackground from '$tablet-app/src/app/components/BlurredBackground';
import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Row from '$tablet-app/src/app/components/Row';
import Text from '$tablet-app/src/app/components/Text';
import { useListCurrentHabitatUsers } from '$tablet-app/src/app/users';
import { useSetCurrentUser } from '$tablet-app/src/app/users/hooks';
import { spacing } from '@akin-home/theme';
import { UserModel } from '@akin-home/user';
import React, { FC } from 'react';
import {
  ScrollView,
  StyleProp,
  ViewStyle,
  useWindowDimensions,
} from 'react-native';
import { Overlay, OverlayProps } from 'react-native-elements';
import styled from 'styled-components/native';
import SwitchProfileMemberGrid from '../SwitchProfileMemberGrid';

interface Props extends OverlayProps {
  onPressSettings?: () => void;
  onRequestClose?: () => void;
}

const SwitchProfileModal: FC<Props> = ({ onPressSettings, ...props }) => {
  const setCurrentUser = useSetCurrentUser();
  const { height, width } = useWindowDimensions();

  const { data: users } = useListCurrentHabitatUsers();

  const onPressProfile = (user: UserModel) => {
    setCurrentUser(user);
    props.onRequestClose?.();
  };

  return (
    <Overlay
      animationType="fade"
      transparent
      overlayStyle={{ height, width, backgroundColor: 'rgba(5, 22, 51, 0.2)' }}
      {...props}
    >
      <BlurredBackground />
      <Header>
        <Title variant="h2" weight="semibold">
          Select profile
        </Title>
        <CloseButtonContainer>
          <NewButton
            variant="secondary"
            icon="times"
            onPress={props.onRequestClose}
            iconColor="white"
          />
        </CloseButtonContainer>
      </Header>

      <ScrollView contentContainerStyle={ScrollContentContainerStyle}>
        <GridContainer>
          <SwitchProfileMemberGrid
            users={users}
            onPressMember={onPressProfile}
          />
        </GridContainer>
      </ScrollView>
    </Overlay>
  );
};

const Header = styled(Row)`
  padding: 16px;
  justify-content: center;
  align-items: center;
`;

const Title = styled(Text)`
  color: white;
`;

const GridContainer = styled.View`
  width: 700px;
  max-width: 100%;
  margin-top: ${spacing[8]}px;
`;

const ScrollContentContainerStyle: StyleProp<ViewStyle> = {
  alignItems: 'center',
};

const CloseButtonContainer = styled.View`
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: ${spacing[3]}px;
  justify-content: center;
`;

export default SwitchProfileModal;
